import axios from "../api/apiConfig";
import { ShipDataType } from "../customTypes/customTypes";

const saveShipData = (shipData: ShipDataType[]) => {
  const p = new Promise((resolve, reject) => {
    axios
      .post("/shipData", shipData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return p;
};

const getShipData = async (clientId: string, vendorId: string) => {
  try {
    const response = await axios.get(
      `/shipData/byClientAndVendor/${clientId}/${vendorId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getShipDataAll = async (fromDate: string, toDate: string) => {
  try {
    const response = await axios.get(`/shipData/${fromDate}/${toDate}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getShipDataByClient = async (
  client_id: string,
  fromDate: string,
  toDate: string
) => {
  try {
    const response = await axios.get(
      `/shipData/${client_id}/${fromDate}/${toDate}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const articleSelection = async (order_no?: string) => {
  try {
    const response = await axios.get(`/shipData/articleSelection/${order_no}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const deleteShipData = async (id?: number) => {
  try {
    const response = await axios.delete(`/shipData/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  saveShipData,
  getShipData,
  articleSelection,
  deleteShipData,
  getShipDataAll,
  getShipDataByClient,
};
